module.exports = __webpack_public_path__ + "static/img/mast_P02K.ee60a93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/mast_P02K.jpg
// module id = ZHCz
// module chunks = 0